import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {workouts, type WorkoutPowerQuality} from '../services/api';
import '../styles/workout-power-quality.css';

export function WorkoutPowerQualityCard({workoutId}: {workoutId: number}) {
 const {t}=useTranslation();
 const [quality,setQuality]=useState<WorkoutPowerQuality|null>(null);
 const [editing,setEditing]=useState(false);
 const [note,setNote]=useState('');
 const [busy,setBusy]=useState(false);
 const [failed,setFailed]=useState(false);
 const [attempt,setAttempt]=useState(0);
 const generation=useRef(0);
 useEffect(()=>{
  const current=++generation.current;
  setQuality(null);setFailed(false);setEditing(false);setNote('');setBusy(false);
  workouts.getPowerQuality(workoutId).then(r=>{if(current===generation.current)setQuality(r.data.data);})
   .catch(()=>{if(current===generation.current)setFailed(true);});
  return ()=>{generation.current=current+1;};
 },[workoutId,attempt]);
 const submit=async(e:React.FormEvent)=>{
  e.preventDefault();if(!quality||busy||note.trim().length<3)return;
  const current=generation.current;setBusy(true);setFailed(false);
  try {const r=await workouts.requestPowerReview(workoutId,quality.version,note.trim());if(current===generation.current){setQuality(r.data.data);setEditing(false);}}
  catch {if(current===generation.current){setFailed(true);try{const r=await workouts.getPowerQuality(workoutId);if(current===generation.current)setQuality(r.data.data);}catch{/* Preserve the failed state and user's note. */}}}
  finally {if(current===generation.current)setBusy(false);}
 };
 if(!quality?.quarantined&&!quality?.restoration_pending&&!failed)return null;
 return <section className="workout-power-quality" aria-label={t('powerQuality.title')}>
  <h3>{t(quality?.quarantined?'powerQuality.title':quality?.restoration_pending?'powerQuality.restoringTitle':'powerQuality.loadError')}</h3>
  {quality?.restoration_pending&&!quality.quarantined&&<p>{t('powerQuality.restoring')}</p>}
  {quality?.quarantined&&<>
   <p>{t(quality.reason==='source_changed'?'powerQuality.sourceReason':quality.reason==='power_duration_review'?'powerQuality.reason':'powerQuality.manualReason')}</p>
   <p>{t('powerQuality.effect')}</p>
   {quality.review_requested?<p role="status">{t('powerQuality.requested')}</p>:editing?<form onSubmit={e=>void submit(e)}>
    <label>{t('powerQuality.noteLabel')}<textarea value={note} onChange={e=>setNote(e.target.value)} minLength={3} maxLength={2000} required disabled={busy}/></label>
    <button type="submit" disabled={busy||note.trim().length<3} aria-busy={busy}>{t('powerQuality.send')}</button>
   </form>:<button type="button" onClick={()=>setEditing(true)}>{t('powerQuality.request')}</button>}
  </>}
  {failed&&<div role="alert"><p>{t(editing?'powerQuality.submitError':'powerQuality.loadError')}</p>{!editing&&<button type="button" onClick={()=>setAttempt(n=>n+1)}>{t('powerQuality.retry')}</button>}</div>}
 </section>;
}
